// extracted by mini-css-extract-plugin
module.exports = {"container":"ScrollMenu_container__K8rkk","menu":"ScrollMenu_menu__GXIFm"};